import React from 'react';
import { Container, Eyebrow, Heading } from '../ui/Section';
import { Button } from '../ui/Button';
import { ControlTowerDashboard } from '../features/ControlTowerDashboard';
import { OperationFlow } from '../features/OperationFlow';
export function ControlTowerPreview() {
  return <section className="bg-graphite-900 py-20 md:py-28" data-id="element-295" data-mp="1g28fwcb435t">
      <Container data-id="element-296" data-mp="1gkchf57nloa">
        <div className="grid gap-10 lg:grid-cols-[1fr_auto] lg:items-end" data-id="element-297" data-mp="1i4uy6e93e5s">
          <div className="max-w-3xl" data-id="element-298" data-mp="39w3z3vbdm5ud">
            <Eyebrow tone="dark" data-id="element-299" data-mp="34witj21paz8o">Control Tower Rabemar</Eyebrow>
            <Heading as="h2" size="lg" tone="dark" className="mt-5" data-id="element-300" data-mp="34ybzef4hpffm">
              Vea su operación.
              <br data-id="element-301" data-mp="3jv31wx9gn79g" />
              Antes de que se convierta en un problema.
            </Heading>
            <p className="mt-6 max-w-2xl text-lg leading-relaxed text-mist-200" data-id="element-302" data-mp="3etdpbd6lalj9">
              Coordinación operativa, seguimiento de transportes, control documental, medición de SLA y evaluación de
              proveedores concentrados en una única vista, con un Account Manager como punto de contacto.
            </p>
          </div>
          <Button to="/soluciones/control-tower" variant="onDark" size="lg" withArrow trackingLocation="home-control-tower" data-id="element-303" data-mp="3ttomkaivgd4p">
            Ver el Control Tower
          </Button>
        </div>

        <div className="mt-12" data-id="element-304" data-mp="6p8qbsv047vw">
          <ControlTowerDashboard data-id="element-305" data-mp="6pik7rj62z6v" />
        </div>

        <div className="mt-16" data-id="element-306" data-mp="6n4n7d4xfcwo">
          <h3 className="text-xs font-semibold uppercase tracking-[0.16em] text-accent-400" data-id="element-307" data-mp="364vz72gbfdlp">
            La operación completa, tramo por tramo
          </h3>
          <div className="mt-5" data-id="element-308" data-mp="3b1clrs7v9jwo">
            <OperationFlow data-id="element-309" data-mp="3f5ala413swq9" />
          </div>
        </div>
      </Container>
    </section>;
}